import React from "react";
import LiteTradeSelectAsset from "../../modules/LiteTrade/components/LiteTradeSelectAsset/LiteTradeSelectAsset.jsx";

function MobileAssets() {
    return <div className="h-100 d-flex flex-column">
        <LiteTradeSelectAsset/>
    </div>
}

export default MobileAssets;
